import type { Middleware } from '@reduxjs/toolkit';

import { clearAuthTokens, setAuthTokens } from '@/lib/authToken';
import { clearAuth, setAccessToken, setTokens } from '@/store/slices/auth.slice';

/**
 * Syncs auth tokens to in-memory store when setTokens/setAccessToken/clearAuth is dispatched.
 * Keeps tokens out of localStorage (XSS risk).
 */
export const authTokenSyncMiddleware: Middleware = () => (next) => (action) => {
  const result = next(action);

  if (setTokens.match(action)) {
    setAuthTokens({
      accessToken: action.payload.accessToken,
      refreshToken: action.payload.refreshToken,
    });
  } else if (setAccessToken.match(action)) {
    setAuthTokens({ accessToken: action.payload });
  } else if (clearAuth.match(action)) {
    clearAuthTokens();
  }

  return result;
};
